// Class: starling.errors.NotSupportedError

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}

// Constructor

var NotSupportedError = function(message,id) {
	if(id == null) {
		id = 0;
	}
	if(message == null) {
		message = "";
	}
	(openfl_errors_Error().default).call(this,message,id);
}

// Meta

NotSupportedError.__name__ = ["starling","errors","NotSupportedError"];
NotSupportedError.__super__ = (openfl_errors_Error().default);
NotSupportedError.prototype = $extend((openfl_errors_Error().default).prototype, {
	
});
NotSupportedError.prototype.__class__ = NotSupportedError.prototype.constructor = $hxClasses["starling.errors.NotSupportedError"] = NotSupportedError;

// Init



// Statics




// Export

exports.default = NotSupportedError;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/errors/NotSupportedError.js
// module id = 82
// module chunks = 0